export const MAIN_CATEGORY = 'salati';
export const SERVICE_ALIAS = 'rb-life-cook';
export const BASE_PATH = '/cook';

export default {
  HEADER_SUPPORT: `${BASE_PATH}/text/${SERVICE_ALIAS}/header-support/1`,
  FOOTER: `${BASE_PATH}/text/${SERVICE_ALIAS}/footer-cook/1`,
  OFFER: `${BASE_PATH}/text/${SERVICE_ALIAS}/oferta/1?replace_aliases=true`,
  PPOLICY: `${BASE_PATH}/text/${SERVICE_ALIAS}/privacypolicy/1`,
  CATEGORIES: `${BASE_PATH}/api/compact-auto?lang=ua`,
  FREE_PREVIEW: `${BASE_PATH}/gate/f/`,
  CONTENT: `${BASE_PATH}/gate/p/`,
  FIREBASE_TOKEN: `${BASE_PATH}/firebase/token`,
};
